module.exports = __webpack_public_path__ + "img/qrCode.4e30c293.png";